import React from 'react';
import LandingHeader from './LandingHeader';
import Footer from './Footer';
import { footerNavigation } from './contentSections';

interface PublicPageLayoutProps {
  title: string;
  subtitle?: string;
  /** Wider main column for split layouts (e.g. careers). Defaults to max-w-5xl. */
  contentMaxWidthClassName?: string;
  children: React.ReactNode;
}

export default function PublicPageLayout({
  title,
  subtitle,
  contentMaxWidthClassName = 'max-w-5xl',
  children,
}: PublicPageLayoutProps) {
  return (
    <div className='bg-white dark:bg-boxdark-2 dark:text-white min-h-screen'>
      <LandingHeader />
      <main className={`mx-auto px-6 pb-20 pt-28 lg:px-8 ${contentMaxWidthClassName}`}>
        <section className='mb-10'>
          <h1 className='text-4xl font-bold tracking-tight text-gray-900 dark:text-white'>{title}</h1>
          {subtitle && <p className='mt-4 text-lg text-gray-600 dark:text-gray-300'>{subtitle}</p>}
        </section>
        <section className='space-y-6 text-gray-700 dark:text-gray-200'>{children}</section>
      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
}
